// TODO where is the best place to put this black magic
const toNonProd = new URLSearchParams(window.location.search).has('non-prod') || window.location.host.includes('nc2-env-rollout')

// export const COVEO_ACCESS_TOKEN = 'xxc997e6c1-d94a-4d9f-b8fb-0c641f6813f3'
// export const COVEO_ORGANIZATION_ID = 'nespressoproductiong3iqhhz5'
export const COVEO_ACCESS_TOKEN = toNonProd
    ? 'xxea192144-c340-457a-bfb0-dfb5cbe4970e'
    : 'xxc997e6c1-d94a-4d9f-b8fb-0c641f6813f3'
export const COVEO_ACCESS_TOKEN_B2B = toNonProd
    ? 'xx847978f3-7957-46fe-9dcf-1b82152e0d9c'
    : 'xxc511eda8-240a-4ba7-a372-49574b86e70b'
export const COVEO_ORGANIZATION_ID = toNonProd
    ? 'nespressononproduction1skusciyz'
    : 'nespressoproductiong3iqhhz5'
export const COVEO_PLATFORM_URL = 'https://platform-eu.cloud.coveo.com'
export const COVEO_API_KEY_RECS = 'xxf96dac22-66c0-438a-a58c-fe13fa817e86'
export const COVEO_API_KEY_CART_RECS = 'xx5a4f431d-da86-4d34-a585-6ddd7e8148de'
export const COVEO_CLIENT_ORIGIN_SEARCH_API_FETCH = 'searchApiFetch'
export const COVEO_CLIENT_ORIGIN_ANALYTICS_FETCH = 'analyticsFetch'
export const COVEO_MAX_RESPONSE_TIME = 8000

export const COVEO_SEARCH_TERM_MIN_LENGTH = 3

export const CAPSULE_TECHNOLOGY_B2B = 'Pro'

export const B2B_PRICE_DISPLAY_ALL = 'ALL'
export const B2B_PRICE_DISPLAY_ONLY_AUTHENTICATED = 'ONLY_AUTHENTICATED'

